import * as z from 'zod/v4';

export const maskSchema = z.coerce.number().int().nonnegative().or(z.undefined());
